module.exports = __webpack_public_path__ + "img/logo-light.d5b1a4bf.png";